import React from 'react';

import { TermsOfUseContentPart1 } from 'pages/terms/TermsOfUseContentPart1';
import { TermsOfUseContentPart2 } from 'pages/terms/TermsOfUseContentPart2';

export const TermsOfUseContent: React.FC = () => {
  return (
    <>
      <TermsOfUseContentPart1 />
      <TermsOfUseContentPart2 />
    </>
  );
};
